// extracted by mini-css-extract-plugin
export default {"tab":"client-components-workTemplate-___workTemplate__tab___1dmVQ"};